import { Button } from "../shared/button/button";
import { useNavigate } from "react-router-dom";
import { ContainerLogin } from "./styles";
import { LinkStyled, NormalText, TextFieldStyled } from "../shared/styles";
import { Box } from "@mui/material";
import { login } from "../redux/actions/user.actions";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Announcement } from "../shared/announcement/announcement";
import { setUser as setUserReducer } from "./../redux/reducers/user";
import { useSelector } from "react-redux";
import { ModalAuthenticator } from "./../shared/modal-authenticator/modal-authenticator";
import { validateEmail } from "../shared/utils";
import { Footer } from "../shared/footer/footer";

export const Login = () => {
  const [user, setUser] = useState({
    username: "",
    password: "",
    error: "",
  });
  const [showModal, setShowModal] = useState(false);

  const {
    data: userData,
    isLoading: isLoadingUser,
    error: errorUser,
  } = useSelector((state) => state.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  function handleLogin(e) {
    if (e?.type === "keydown" && e.key !== "Enter") {
      setUser({ ...user, error: "" });
      return;
    }

    if (!validateEmail(user.username)) {
      setUser((prev) => ({
        ...prev,
        error:
          "Please enter a valid email address in the format: user@example.com",
      }));
      return;
    }

    dispatch(login(user.username, user.password, ""));
  }

  function handleLoginWithGoogle() {}

  function handleShowModal() {
    setShowModal((prev) => !prev);
  }

  function handleChangeUser(e) {
    dispatch(
      setUserReducer({
        data: null,
        isLoading: false,
        error: null,
      })
    );
    setUser({ ...user, [e.target.name]: e.target.value });
  }

  useEffect(() => {
    if (userData?.usuarioid) {
      navigate("/home");
    }
  }, [navigate, userData]);

  useEffect(() => {
    if (errorUser?.includes("@")) {
      handleShowModal();
      setUser({ ...user, email: errorUser?.split(" ").at(-1) });
    }
  }, [errorUser]);

  return (
    <ContainerLogin>
      <ModalAuthenticator
        email={user.email}
        username={user.username}
        password={user.password}
        showModal={showModal}
        handleShowModal={handleShowModal}
      />
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={"24px"}
        alignItems={"center"}
      >
        <img src="/logo-tenui.png" alt="Logo Tenui" width={72} />
        {/* <img
          src="/logo-develone-2.png"
          alt="Logo Develone"
          width={72}
        /> */}
        <NormalText>
          Welcome to your space to work with all types of transactions. Crypto
          and cash in one place.
        </NormalText>
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <TextFieldStyled
          name={"username"}
          placeholder={"Username"}
          type={"text"}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
          onChange={handleChangeUser}
          onKeyDown={handleLogin}
        />
        <TextFieldStyled
          name={"password"}
          placeholder={"Password"}
          type={"password"}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
          autoComplete="new-password"
          onChange={handleChangeUser}
          onKeyDown={handleLogin}
        />
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <Button
          label={"Login"}
          fullWidth
          onClick={handleLogin}
          buttonStyles={{
            padding: "12px",
            minHeight: "47px",
          }}
          isLoading={isLoadingUser}
        />
        <Button
          label={"Continue with Google"}
          fullWidth
          onClick={handleLoginWithGoogle}
          startIcon={"GoogleLogo"}
          buttonStyles={{
            padding: "12px",
          }}
          isDisabled
          tooltipLabel={"This feature is not available yet"}
        />
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <LinkStyled href="/forgot-password" underline="none">
          Forgot password?
        </LinkStyled>
      </Box>
      {(errorUser || user.error) && !showModal && (
        <Announcement
          title={(!!errorUser || !!user.error) && "Error"}
          description={errorUser || user.error}
          type={!!errorUser || !!user.error ? "error" : "info"}
        />
      )}
      <Footer />
    </ContainerLogin>
  );
};
